import type {PermissionsRecordType} from '../permissions';

export const settingsPermissions = {
  readSettings: {
    actionId: 'READ',
    resourceId: 'SETTINGS',
    scopes: [],
  },
  configureBackgroundRemoval: {
    actionId: 'CONFIGURE_BACKGROUND_REMOVAL',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  configurePhotoGuide: {
    actionId: 'CONFIGURE_PHOTO_GUIDE',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  configureDescriptionGenerator: {
    actionId: 'CONFIGURE_DESCRIPTION_GENERATOR',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  setPurchasePriceCosts: {
    actionId: 'SET_PURCHASE_PRICE_COSTS',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  readPurchasePriceRules: {
    actionId: 'READ_PURCHASE_PRICE_RULES',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  managePurchasePriceRules: {
    actionId: 'MANAGE_PURCHASE_PRICE_RULES',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  setFinanceSettings: {
    actionId: 'SET_FINANCE_SETTINGS',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  toggleTenantPlatform: {
    actionId: 'TOGGLE_TENANT_PLATFORM',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  remapCustomCatalogueEntry: {
    actionId: 'REMAP_CUSTOM_CATALOGUE_ENTRY',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  updateTitleExtensionEquipment: {
    actionId: 'UPDATE_TITLE_EXTENSION_EQUIPMENT',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  enableWarehouseManagement: {
    actionId: 'ENABLE_WAREHOUSE_MANAGEMENT',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  disableWarehouseManagement: {
    actionId: 'DISABLE_WAREHOUSE_MANAGEMENT',
    resourceId: 'SALES_SETTINGS',
    scopes: [],
  },
  readCustomFieldsDefinitions: {
    resourceId: 'FIELD_DEFINITION',
    actionId: 'READ',
    scopes: [],
  },
  removeCustomFieldsDefinitions: {
    resourceId: 'FIELD_DEFINITION',
    actionId: 'REMOVE_TENANT_FIELD_DEFINITION',
    scopes: [],
  },
  updateCustomFieldsDefinitions: {
    resourceId: 'FIELD_DEFINITION',
    actionId: 'UPDATE_TENANT_FIELD_DEFINITION',
    scopes: [],
  },
  addCustomFieldsDefinitions: {
    resourceId: 'FIELD_DEFINITION',
    actionId: 'ADD_TENANT_FIELD_DEFINITION',
    scopes: [],
  },
  createMessageTemplate: {
    resourceId: 'CONTEXT_TEMPLATE',
    actionId: 'CREATE',
    scopes: [],
  },
  patchMessageTemplate: {
    resourceId: 'CONTEXT_TEMPLATE',
    actionId: 'PATCH',
    scopes: [],
  },
  teamRead: {
    resourceId: 'TEAM',
    actionId: 'READ',
    scopes: [],
  },
  teamCreate: {
    resourceId: 'TEAM',
    actionId: 'CREATE',
    scopes: [],
  },
  teamUpdate: {
    resourceId: 'TEAM',
    actionId: 'UPDATE',
    scopes: [],
  },
  teamDelete: {
    resourceId: 'TEAM',
    actionId: 'DELETE',
    scopes: [],
  },
  readFacebookLeads: {
    actionId: 'READ',
    resourceId: 'FACEBOOK_LEAD',
    scopes: [],
  },
  aiLeadSettingsRead: {
    actionId: 'READ',
    resourceId: 'AI_LEAD_SETTINGS',
    scopes: [],
  },
  aiLeadSettingsUpdate: {
    actionId: 'UPDATE',
    resourceId: 'AI_LEAD_SETTINGS',
    scopes: [],
  },
  updatePhotoCheckerConfig: {
    resourceId: 'INTEGRATED_SERVICE',
    actionId: 'UPDATE_PHOTO_CHECKER_CONFIG',
    scopes: [],
  },
  updateAutotracerPlConfig: {
    resourceId: 'INTEGRATED_SERVICE',
    actionId: 'UPDATE_AUTOTRACER_PL_CONFIG',
    scopes: [],
  },
  updateDatVinDecoderConfig: {
    resourceId: 'INTEGRATED_SERVICE',
    actionId: 'UPDATE_DAT_VIN_DECODER_CONFIG',
    scopes: [],
  },
} satisfies PermissionsRecordType;
